module.exports = __webpack_public_path__ + "static/media/private-payroll-background.7c233bd8.jpg";